<template>
  <el-table-column
    prop="enter"
    sortable="custom"
    label="Belépés"
    min-width="120"
  >
    <template slot-scope="scope">
      {{ scope.row.enter_time }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'location.value',
  };
</script>
